/**
 * wizardContextBuilder - Funcoes puras para gerar mensagens contextuais
 * baseadas no estado da entity tree do wizard.
 *
 * Usado pelo EntityPickerStep para adaptar titulos e subtitulos
 * de acordo com o que ja foi selecionado nos steps anteriores.
 */

/**
 * Formata lista de nomes no padrao "A, B e C".
 * @param {Array<{name: string}>} items
 * @returns {string}
 */
function formatNames(items) {
  const names = items.map(i => i.name);
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} e ${names[1]}`;
  return `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
}

/**
 * Gera subtitulo contextual para um entity picker,
 * baseado nas entidades ja selecionadas de outros tipos.
 *
 * @param {'professional' | 'service' | 'place'} entityType
 * @param {object} tree - entityTree.tree
 * @returns {string|null} - subtitulo contextual ou null se nao ha contexto
 */
export function buildContextSubtitle(entityType, tree) {
  const selectedServices = tree.services.filter(s => s.selected);
  const selectedProfs = tree.professionals.filter(p => p.selected);
  const selectedPlaces = tree.places.filter(p => p.selected);

  switch (entityType) {
    case 'professional':
      if (selectedServices.length > 0) {
        return `Quem prestara os servicos ${formatNames(selectedServices)}?`;
      }
      return null;

    case 'service':
      if (selectedProfs.length > 0) {
        return `Quais servicos ${formatNames(selectedProfs)} irao prestar?`;
      }
      return null;

    case 'place':
      if (selectedProfs.length > 0 && selectedServices.length > 0) {
        return `Onde ${formatNames(selectedProfs)} irao prestar ${formatNames(selectedServices)}?`;
      }
      if (selectedProfs.length > 0) {
        return `Onde ${formatNames(selectedProfs)} irao atuar?`;
      }
      if (selectedServices.length > 0) {
        return `Onde os servicos ${formatNames(selectedServices)} serao oferecidos?`;
      }
      return null;

    default:
      return null;
  }
}

export { formatNames };
